export default "__VITE_ASSET__2nEfda1x__";